<template>
  <div v-show="loading">
    <div
      class="loading-container w-100 h-100 d-flex justify-content-center align-items-center"
    >
      <img
        height="100"
        width="100"
        :src="require(`../../assets/icons/coffee.svg`)"
      />
    </div>
    <div id="not-loading" v-if="!loading"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "LoadingOverlay",
  computed: {
    ...mapState("layout", {
      loading: state => state.loading
    })
  }
};
</script>

<style scoped>
.loading-container {
  z-index: 9999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(233, 236, 239, 0.8) !important;
}
</style>
